
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/katalogowanie-telefonem-smartfonem-qr-czytnikiem-isbn",
      function () {
        return require("private-next-pages/docs/katalogowanie-telefonem-smartfonem-qr-czytnikiem-isbn.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/katalogowanie-telefonem-smartfonem-qr-czytnikiem-isbn"])
      });
    }
  